// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowUp from "@insite/mobius/Icons/ArrowUp";
import { listStyles } from "@west/Overrides/Widgets/Brand/BrandList";
import { color, ellipsis, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

listStyles.brandLetter = {
    variant: "h3",
    size: 24,
    lineHeight: "36px",
    weight: "bold",
    css: css`
        text-transform: uppercase;
        margin-bottom: 0;
    `,
};

listStyles.backToTopLink = {
    icon: {
        iconProps: {
            src: ArrowUp,
        },
    },
    typographyProps: {
        size: 14,
        weight: "bold",
        lineHeight: "16px",
        css: css`
            letter-spacing: 0;
            display: flex;
            align-items: center;
        `,
    },
};

listStyles.brandLink = {
    typographyProps: {
        size: 16,
        lineHeight: "18px",
        weight: "bold",
        ellipsis: true,
        css: css`
            white-space: normal;
        `,
    },
    css: css`
        align-self: start;
    `,
};

listStyles.brandSections = {
    css: css`
        display: flex;
        flex-direction: column;
        &:not(:last-child) {
            margin-bottom: 32px;
        }
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 12px;
    `,
};

listStyles.allBrandsTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "md")} {
            word-break: break-word;
            ${ellipsis(2)}
        }
    `,
};

listStyles.clearFiltersButton = {
    variant: "tertiary",
};

listStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 24px;
    `,
};

listStyles.brandItem = {
    css: css`
        padding: 0;
        display: flex;
        width: 50%;
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
        ${xScreen("gt", "md")} {
            width: calc(100% / 4);
        }
    `,
};

listStyles.brandItems = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 15px;
    `,
};

listStyles.searchKeyTitleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
    `,
};
